import { render, staticRenderFns } from "./PaginaAsignacionCamposResultados.vue?vue&type=template&id=2619d81b"
import script from "./PaginaAsignacionCamposResultados.vue?vue&type=script&lang=js"
export * from "./PaginaAsignacionCamposResultados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports